import { call, takeEvery } from 'redux-saga/effects';
import { TRACK_PLAY_SCRIBE } from 'JS/actionCreators/trackingActions';

import { track } from '../mixpanelProvider';

const actions = {
  fromElement: 'Play Video From Element',
  fromScene: 'Play Video From Scene',
  fromStart: 'Play Video From Start'
};

function* trackPlayScribe({ button = 'fromStart', scribeId, sceneCount, eventTrigger }) {
  const action = actions[button];
  yield call(track, action, { 'Scribe ID': scribeId, 'Number of Scenes': sceneCount, 'Event Trigger': eventTrigger });
}

export default function* trackTimelineSagas() {
  yield takeEvery(TRACK_PLAY_SCRIBE, trackPlayScribe);
}
